invHdApp.controller('LocationController',
  ['$scope', 'Location', '$location', 'FileUploader', '$localStorage', '$filter', '$routeParams', '$http',
    function ($scope, Location, $location, FileUploader, $localStorage, $filter, $routeParams, $http) {
      $scope.address = 0;
      $scope.deleted = [];
      $scope.update = {};
      $scope.edit = [];
      $scope.newAdress = {};

      $scope.selectAll = function (select) {
        if (select) {
          $scope.deleted = [];
          for (let i = 0; i < $scope.data.locations.data.length; i++) {
            $scope.deleted.push($scope.data.locations.data[i].id);
          }
        } else {
          $scope.deleted = [];
        }
      };

      $scope.$on('new_data', function () {
        $scope.newLocation();
        $('#newLocation').modal('show');
      }, true);

      $scope.$on('edit_data', function (event, data) {
        $scope.show(data);
      }, true);

      $scope.filterProp = [];

      $scope.filterData = {
        locations: [],
        receiver_type: 'individual',
        page: 1,
        created_at: {
          startDate: null,
          endDate: null
        },
      }

      $scope.addFilterProps = function (item) {
        if ($scope.filterProp.indexOf(item) === -1)
          $scope.filterProp.push(item);
        else {
          var index = $scope.filterProp.indexOf(item);
          $scope.filterProp.splice(index, 1);
          $scope.filterData[item] = "";
          if ($scope.filterProp.length == 0) {
            $scope.filter('clear');
          }
        }
      }

      $scope.getPage = function (page) {
        $scope.filterData.page = page;
        $scope.filter();
      }

      $scope.sort = function (field, sort) {
        $scope.filterData.field = field;
        $scope.filterData.sort = sort;
        $scope.filter();
      }

      $scope.filter = function (type) {
        if (type == 'clear') {
          $scope.filterData = {
            locations: [],
            companies: [],
            receiver_type: 'individual',
            page: 1,
            created_at: {
              startDate: null,
              endDate: null
            },
            scheduled_time: {
              startDate: null,
              endDate: null
            }
          }
          $scope.filterProp = [];
        } else {
          $scope.filterData.filterProp = $scope.filterProp;
          if (typeof $scope.filterData.created_at.endDate !== 'undefined' && $scope.filterData.created_at.endDate !== null) {
            $scope.filterData.filterProp.created_at = 'created_at';
          }
          if (typeof $scope.filterData.scheduled_time.endDate !== 'undefined' && $scope.filterData.scheduled_time.endDate !== null) {
            $scope.filterData.filterProp.scheduled_time = 'scheduled_time';
          }
        }
        $scope.init();
      }

      $scope.$on('refresh_data', function () {
        console.log('refreshing locations...')
        $scope.init();
      }, true);

      $scope.init = function (receiver_type = 'corporate') {
        $scope.filterData.receiver_type = receiver_type;
        Location.init($scope.filterData).success(function (data, status, headers, config) {
          $scope.data = data;
          if (typeof $scope.filterData.filterProp !== 'undefined') {
            $scope.filterProp = [];
            if (angular.isArray($scope.filterData.filterProp)) {
              for (var i = $scope.filterData.filterProp.length - 1; i >= 0; i--) {
                $scope.filterProp.push($scope.filterData.filterProp[i])
              }
            } else {
              $scope.filterProp.push($scope.filterData.filterProp);
            }
          }
          if ($routeParams.new) {
            setTimeout(() => {
              $scope.newLocation();
              $('#newLocation').modal('show');
            }, 300);
          }
        });
      };

      $scope.newLocation = function () {
        Location.newLocation().success(function (data, status, headers, config) {
          $scope.location = {}
        });
      };

      $scope.getAddress = function (gAddress) {
        if (typeof gAddress.latitude !== 'undefined') {
          var location = new google.maps.LatLng(gAddress.latitude, gAddress.longitude);
          // $scope.map.setCenter(location);
          // $scope.marker.setDuration(1000);
          // $scope.marker.setEasing("swing");
          // $scope.marker.setPosition(location);
          $scope.location.latitude = gAddress.latitude;
          $scope.location.longitude = gAddress.longitude;
          $scope.location.city = gAddress.city;
          $scope.location.state = gAddress.state;
          var address = ''
          if (gAddress.street) {
            address += gAddress.street + ' '
          }
          if (gAddress.number) {
            address += gAddress.number
          }
          $scope.location.zipcode = gAddress.zipcode ? gAddress.zipcode : gAddress.zip;
          $scope.location.address = address;
          $scope.states.forEach(element => {
            if (element.abbreviation == gAddress.city) {
              $scope.location.state = element.name;
              return true;
            }
          });
        }
      }

      $scope.saveLocation = function (location) {
        Location.saveLocation(location).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          // $location.path('musteri-yonetimi');
          $('#newLocation').modal('hide');
          $scope.init()
        }).error(function (data) {
          Messenger().post({ message: data.message, type: "error" });
        });
      };

      $scope.delete = function (type) {
        if (type == 'set') {
          $('#delete').modal('show');
        } else if (type == 'delete') {
          var txt;
          var r = confirm("Silmek istediğinize emin misiniz ? Bu işlem geri alınamaz bir işlemdir!");
          if (r == true) {
            Location.deleteLocation($scope.deleted).success(function (data, status, headers, config) {
              Messenger().post(data.message);
              $scope.init();

              $scope.deleted = [];
            }).error(function (data) {
              Messenger().post({ message: data.message, type: "error" });
            });
          }
        } else if (type == 'all') {
          var txt;
          var r = confirm("Tüm müşterileri silmek istediğinize emin misiniz ? Bu işlem geri alınamaz bir işlemdir!");
          if (r == true) {
            Location.deleteLocation({ type: 'all' }).success(function (data, status, headers, config) {
              Messenger().post(data.message);
              $scope.init();

              $scope.deleted = [];
            }).error(function (data) {
              Messenger().post({ message: data.message, type: "error" });
            });
          }
        }
      };

      $scope.updateLocation = function () {
        $scope.location.permissionSteps = $scope.permissionSteps;
        Location.updateLocation($scope.location).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          $('#editLocation').modal('hide');
          $scope.getLocationDetails($scope.location.id);
        }).error(function (data) {
          Messenger().post({ message: data.message, type: "error" });
        })
      };

      $scope.addAddress = function () {
        $scope.newAdress.company_location_id = $scope.location.id;
        Location.addAddress($scope.newAdress).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          $scope.location = data[0];
          $scope.newAdress = {};
        }).error(function (data) {
          Messenger().post({ message: data.message, type: "error" });
        });
      };

      $scope.show = function (data) {
        Location.show(data.id).success(function (data, status, headers, config) {
          $scope.location = data.location;
          $('#editLocation').modal('show');
        });
      }

      $scope.toggleSelection = function toggleSelection(id) {
        var idx = $scope.deleted.indexOf(id);
        if (idx > -1) {
          $scope.deleted.splice(idx, 1);
        }
        else {
          $scope.deleted.push(id);
        }
      };
    }
  ]);